<template>
  <v-card height="100%">
    <v-container fluid>
      <v-row no-gutters>
        <v-col>
          <h2 class="title">Total de equipos en servicio.</h2>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <v-row style="height:200px" justify="center" align="center">
        <v-col cols="6" class="text-center">
          <span class="display-3 red--text">{{ openServicesAtWorkshop }}</span>
          <br />
          <span class="title heading_name lighten-2">Taller</span>
        </v-col>
        <v-col cols="6" class="text-center">
          <span class="display-3 red--text">{{ openServicesAtWork }}</span>
          <br />
          <span class="title heading_name lighten-2">Obra</span>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>
<script>
import { mapState, mapActions } from "vuex";
export default {
  mounted() {
    if (this.$route.params.branchOffice) {
      this.getOpenServicesTotal({
        service: "Obra",
        branch: this.$route.params.branchOffice
      });
      this.getOpenServicesTotal({
        service: "Taller",
        branch: this.$route.params.branchOffice
      });
    } else {
      this.getOpenServicesTotal({
        service: "Obra"
      });
      this.getOpenServicesTotal({
        service: "Taller"
      });
    }
  },
  computed: {
    ...mapState("services", ["openServicesAtWork", "openServicesAtWorkshop"])
  },
  methods: {
    ...mapActions("services", ["getOpenServicesTotal"])
  },
  watch: {
    "$route.params.branchOffice": {
      handler: function(branch) {
        if (branch) {
          this.getOpenServicesTotal({
            service: "Obra",
            branch: branch
          });
          this.getOpenServicesTotal({
            service: "Taller",
            branch: branch
          });
        } else {
          this.getOpenServicesTotal({
            service: "Obra"
          });
          this.getOpenServicesTotal({
            service: "Taller"
          });
        }
      },
      deep: true,
      immediate: true
    }
  }
  // watch: {
  //   "$route.params.branchOffice": {
  //     handler: function(branch) {
  //       console.log(branch);
  //     },
  //     deep: true,
  //     immediate: true
  //   }
  // }
};
</script>
<style lang="css" scoped>
.title {
  font-weight: 400 !important;
  color: black;
  font-size: 16px !important;
}
.heading_name {
  color: #838383;
  font-size: 30px !important;
  font-weight: 300 !important;
}
.display-3 {
  font-weight: 400 !important;
}
</style>
